<template>
  <div>
    <VerMovimiento></VerMovimiento>
    <ag-grid-vue
      style="width: 100%; height: 60vh"
      class="ag-theme-alpine"
      @grid-ready="onGridReady"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :getContextMenuItems="getContextMenuItems"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import TablaBindings from "./TablaBindings";
import VerMovimiento from "../Show/VerMovimiento";

export default {
  name: "CajaTabla",
  components: {
    AgGridVue,
    VerMovimiento,
  },
  mixins: [TablaBindings],
};
</script>
